import { ArchivalAction } from '../../constants/filter';
import { IcatuStatus } from '../../constants/icatuCap';
import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import {
    CountResponse,
    PaginatedRequest,
    PaginatedResponse,
} from '../../lib/pagination';
import { IcatuCapListingSnapshot } from '../../models/IcatuCap';
import api from '../api';
import qs from 'query-string';

type IcatuCapRequestFilter = {
    address?: string;
    name?: string;
    status?: IcatuStatus[];
    isArchived?: boolean;
};

type RawIcatuCapPaginatedResponse = {
    caps: IcatuCapListingSnapshot[];
} & PaginatedResponse;

type IcatuCapPaginatedResponse = {
    caps: IcatuCapListingSnapshot[];
} & PaginatedResponse;

const createCap = (): Promise<IcatuCapListingSnapshot> =>
    api.request<IcatuCapListingSnapshot>({
        url: `${getBackVersion()}/agent/cap`,
        method: 'POST',
    });

const getIcatuCapsCount = (
    params: PaginatedRequest & IcatuCapRequestFilter
): Promise<CountResponse> => {
    return api.request<CountResponse>({
        method: 'GET',
        url: `${getBackVersion()}/agent/cap/count`,
        params: decamelizeKeys(params),
    });
};

const getPaginatedIcatuCaps = (
    params: PaginatedRequest & IcatuCapRequestFilter = {}
): Promise<IcatuCapPaginatedResponse> => {
    return api
        .request<RawIcatuCapPaginatedResponse>({
            method: 'GET',
            url: `${getBackVersion()}/agent/cap`,
            params: decamelizeKeys(params),
            paramsSerializer: params => {
                // {a: [2, 3]} -> ?a=2&a=3
                // which is the supported format by the backend
                return qs.stringify(params, { arrayFormat: 'none' });
            },
        })
        .then(response => ({
            caps: response.caps,
            after: response.after,
            count: response.count,
        }));
};

const archiveCap = (capId: string, action: ArchivalAction): Promise<void> => {
    return api.request({
        url: `${getBackVersion()}/agent/cap/` + capId,
        method: 'DELETE',
        params: { action },
    });
};

export { createCap, getIcatuCapsCount, getPaginatedIcatuCaps, archiveCap };
export type { IcatuCapPaginatedResponse, IcatuCapRequestFilter };
